// The imprint's number of colors (Stephanie 2026-10-26: "lets change it so
// its a drop down. 1, 2, 3, 4, 5, 6, and full color"). Full color is kept in
// the same color_count field as FULL_COLOR_COUNT, so it carries over wherever
// the count already does (copied quotes, reorders, POs) with no database
// step. Always show it through colorCountWords — never print the raw number.

export const FULL_COLOR_COUNT = 99;

/** The dropdown's choices, in order. */
export const IMPRINT_COLOR_CHOICES: ReadonlyArray<{ value: number; label: string }> = [
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 3, label: "3" },
  { value: 4, label: "4" },
  { value: 5, label: "5" },
  { value: 6, label: "6" },
  { value: FULL_COLOR_COUNT, label: "Full color" },
];

/** Pure: "1 color", "3 colors", "Full color", or null when not set (0 / null). */
export function colorCountWords(n: number | null | undefined): string | null {
  if (n === null || n === undefined || !Number.isFinite(n) || n <= 0) return null;
  if (n === FULL_COLOR_COUNT) return "Full color";
  return n === 1 ? "1 color" : `${n} colors`;
}
